




































































































import { Vue, Component } from "vue-property-decorator"
import EnneagramSvg from "../assets/enneagram/Enneagram.svg"
import EnneaNumber from "./EnneaNumber.vue"
import Ref from "./Ref.vue"
import CenterInfoModal from "./CenterInfoModal.vue"
import names from "@/data/names"
import references from "@/data/references"
import { contents, emotions } from "@/data/contents"
import { centerIds } from "@/data/centers"
import SvgPanZoom from "vue-svg-pan-zoom"

@Component({
  components: {
    EnneagramSvg,
    EnneaNumber,
    CenterInfoModal,
    Ref,
    SvgPanZoom,
  },
})
export default class Enneagram extends Vue {
  get showContents() {
    const combinedContents: any = {
      showArrowsIntegration: this.showArrowsIntegration,
      showArrowsDisintegration: this.showArrowsDisintegration,
    }
    for (const key of this.showPlainContents) {
      combinedContents[key] = true
    }
    return combinedContents
  }
  // getters needed to make imported data available to template

  get centerIds() {
    return centerIds
  }

  get names() {
    return names
  }

  get references() {
    return references
  }

  get emotions() {
    return emotions
  }

  get contents() {
    return contents
  }

  public showHelpers = false
  public showCenters = true
  public showNumbers = [1, 2, 3, 4, 5, 6, 7, 8, 9]
  public showPlusMinus = true
  public showArrowsIntegration = false
  public showArrowsDisintegration = false
  public showAxes = false
  public showSocialStyles = false
  public showNames = ["hurley_dobson"]
  public showEmotions = ["enneallionce", "reifarth", "riso_hudson"]
  public showPlainContents = ["Grundangst", "Grundbedürfnis"]
  public tabIndex = 1
  public useVerticalMenu = true

  public created() {
    // adjust the orientation of the tab list, depending on device orientation

    // https://stackoverflow.com/a/11734939/1480587
    // https://davidwalsh.name/orientation-change
    const mql = window.matchMedia("(orientation: portrait)")

    // If there are matches, we're in portrait
    this.useVerticalMenu = mql.matches // true if orientation: portrait
    // console.log("useVerticalMenu:", this.useVerticalMenu, " --- ", this)

    // Add a media query change listener
    mql.addListener((m) => {
      this.useVerticalMenu = mql.matches // true if orientation: portrait
      // console.log("useVerticalMenu:", this.useVerticalMenu, " --- ", this)
    })
  }

  public showNumber(n: number) {
    return this.showNumbers.indexOf(n) >= 0
  }

  protected activatedCssClasses() {
    const cssClasses: any = {
      showHelpers: this.showHelpers,
      hideHelpers: !this.showHelpers,
      showCenters: this.showCenters,
      hideCenters: !this.showCenters,
      showPlusMinus: this.showPlusMinus,
      hidePlusMinus: !this.showPlusMinus,
      showArrowsIntegration: this.showArrowsIntegration,
      hideArrowsIntegration: !this.showArrowsIntegration,
      showArrowsDisintegration: this.showArrowsDisintegration,
      hideArrowsDisintegration: !this.showArrowsDisintegration,
      showAxes: this.showAxes,
      hideAxes: !this.showAxes,
      showSocialStyles: this.showSocialStyles,
      hideSocialStyles: !this.showSocialStyles,
    }
    for (let i = 1; i <= 9; i++) {
      if (this.showNumber(i)) {
        cssClasses["showNumber" + i] = true
      }
    }
    return cssClasses
  }

  protected onSwipe(event: any) {
    if (event.type === "swipeleft") {
      this.$router.push("/references")
    } else {
      this.$router.push("/")
    }
  }
}
